export const data: Record<
  string,
  {
    arTitle: string
    usTitle: string
    description: string
    accountNumber: string
    alias: string
    cbuCvu: string
    entity: string
    editAlias: string
    editAliasDescription: string
    copyAlias: string
    copyAliasDescription: string
    editAliasTitle: string
    editAliasSubtitle: string
    aliasLabel: string
    aliasPlaceholder: string
    saveButton: string
    aliasRequiredError: string
  }
> = {
  'pt-BR': {
    arTitle: 'Conta Argentina',
    usTitle: 'Conta Global',
    description: 'Dados de recebimento da conta',
    accountNumber: 'Número de conta',
    alias: 'Alias',
    cbuCvu: 'CBU/CVU',
    entity: 'Entidade bancária',
    editAlias: 'Editar alias',
    editAliasDescription: 'Altere o nome do seu alias',
    copyAlias: 'Copiar alias',
    copyAliasDescription: 'Copie o alias para a área de transferência',
    editAliasTitle: 'Editar alias',
    editAliasSubtitle: 'Digite o novo alias para sua conta',
    aliasLabel: 'Alias',
    aliasPlaceholder: 'Digite seu alias',
    saveButton: 'Salvar',
    aliasRequiredError: 'O alias é obrigatório',
  },
  'en-US': {
    arTitle: 'Argentine account',
    usTitle: 'Global account',
    description: 'Your account information',
    accountNumber: 'Account Number',
    alias: 'Alias',
    cbuCvu: 'CBU/CVU',
    entity: 'Entity',
    editAlias: 'Edit alias',
    editAliasDescription: 'Change your alias name',
    copyAlias: 'Copy alias',
    copyAliasDescription: 'Copy alias to clipboard',
    editAliasTitle: 'Edit alias',
    editAliasSubtitle: 'Enter the new alias for your account',
    aliasLabel: 'Alias',
    aliasPlaceholder: 'Enter your alias',
    saveButton: 'Save',
    aliasRequiredError: 'Alias is required',
  },
  'es-ES': {
    arTitle: 'Cuenta Argentina',
    usTitle: 'Cuenta Global',
    description: 'Los datos de su cuenta',
    accountNumber: 'Número de cuenta',
    alias: 'Alias',
    cbuCvu: 'CBU/CVU',
    entity: 'Entidad',
    editAlias: 'Editar alias',
    editAliasDescription: 'Cambie el nombre de su alias',
    copyAlias: 'Copiar alias',
    copyAliasDescription: 'Copiar alias al portapapeles',
    editAliasTitle: 'Editar alias',
    editAliasSubtitle: 'Ingrese el nuevo alias para su cuenta',
    aliasLabel: 'Alias',
    aliasPlaceholder: 'Ingrese su alias',
    saveButton: 'Guardar',
    aliasRequiredError: 'El alias es obligatorio',
  },
}
